import ROUTES from 'router/routes.constants';

/**
 * Profile sub-navigation, shared by every profile screen so the strip is
 * identical wherever it renders. Each screen used to carry its own copy, which
 * is how Mandates ended up missing from four of the five tabs.
 */
export const PROFILE_TABS = [
  { label: 'Personal Details', href: ROUTES.PROFILE_PERSONAL_DETAILS },
  { label: 'Nominee Details', href: ROUTES.PROFILE_NOMINEE_DETAILS },
  { label: 'Bank Details', href: ROUTES.PROFILE_BANK_DETAILS },
  { label: 'My Plan', href: ROUTES.PROFILE_MY_PLAN },
  { label: 'Mandates', href: ROUTES.PROFILE_MANDATES },
];

/** Index of the tab owning a pathname, or -1 when none matches. */
export const getActiveProfileTabIndex = (pathname) => {
  if (!pathname || typeof pathname !== 'string') return -1;
  return PROFILE_TABS.findIndex((tab) =>
    pathname.includes(tab.href.substring(1)),
  );
};
